import { render, staticRenderFns } from "./ButtonConfirm.vue?vue&type=template&id=49ca9356"
import script from "./ButtonConfirm.vue?vue&type=script&lang=js"
export * from "./ButtonConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports